import React from 'react';
import { Button, ThreeDotsLoader } from 'wix-ui-tpa';
import { PublicPlan } from '@wix/ambassador-pricing-plans-v2-plan/types';
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import { useTranslation, useEnvironment } from '@wix/yoshi-flow-editor';
import { VIEWER_HOOKS } from '../../../../../constants';
import { useSettingsParams } from '../../../../../hooks';
import { ButtonStyle } from '../../../settingsParams';
import stylesParams from '../../../stylesParams';
import { st, classes } from './Cta.st.css';

interface Props {
  plan: PublicPlan;
  highlighted: boolean;
  loading: boolean;
  onClick: () => void;
}

enum ButtonStyleStylableFlag {
  emptyCornered = 'emptyCornered',
  emptyRounded = 'emptyRounded',
  fullCornered = 'fullCornered',
  fullRounded = 'fullRounded',
}

export const Cta: React.FC<Props> = ({ highlighted, plan, onClick, loading }) => {
  const settingsParams = useSettingsParams();
  const settings = useSettings();
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const styles = useStyles();
  const hasFreeTrial = !!plan.pricing?.freeTrialDays;

  const renderText = () => {
    if (hasFreeTrial) {
      return settings.get(settingsParams.freeTrialButtonText) || t('pp.defaults.freeTrialButton');
    }

    return settings.get(settingsParams.buttonText) || t('pp.defaults.button');
  };

  return (
    <Button
      data-hook={VIEWER_HOOKS.PLAN_CTA}
      onClick={onClick}
      className={st(classes.root, {
        highlighted,
        loading,
        mobile: isMobile,
        style: buttonStyleToStylableFlag(styles.get(stylesParams.buttonStyle)),
      })}
    >
      <span className={classes.label}>{renderText()}</span>
      {loading && (
        <div className={classes.loaderContainer}>
          <ThreeDotsLoader data-hook={VIEWER_HOOKS.PLAN_CTA_LOADER} className={classes.loader} />
        </div>
      )}
    </Button>
  );
};

function buttonStyleToStylableFlag(buttonStyle: ButtonStyle): ButtonStyleStylableFlag {
  switch (buttonStyle) {
    case ButtonStyle.EMPTY_CORNERED:
      return ButtonStyleStylableFlag.emptyCornered;
    case ButtonStyle.EMPTY_ROUNDED:
      return ButtonStyleStylableFlag.emptyRounded;
    case ButtonStyle.FULL_ROUNDED:
      return ButtonStyleStylableFlag.fullRounded;
    default:
    case ButtonStyle.FULL_CORNERED:
      return ButtonStyleStylableFlag.fullCornered;
  }
}
